import { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';

const BookingItemTitle = ({ placeholder, byline, onClickExpand, doShowExpandMore }) => {
  const classes =
    'mt-6 sm:mx-5 mx-2 float-right cursor-pointer text-theme MuiSvgIcon-fontSizeLarge';
  return (
    <div
      className={clsx('w-full border-b-2 border-theme', {
        'border-none': onClickExpand && !doShowExpandMore,
      })}
    >
      <span
        className={clsx(
          'text-theme m-6 sm:mx-6 mx-2 inline-block font-inter font-normal sm:text-2xl text-xl',
          { 'mb-1': byline },
        )}
      >
        <span className="text-subHeading font-subHeading">{placeholder}</span>
      </span>
      {byline && <div className="ml-6 mb-2 sm:text-xs xl:text-sm text-gray-600">{byline}</div>}
      {onClickExpand &&
        (doShowExpandMore ? (
          <ExpandLessOutlinedIcon className={classes} onClick={onClickExpand} />
        ) : (
          <ExpandMoreOutlinedIcon className={classes} onClick={onClickExpand} />
        ))}
    </div>
  );
};

BookingItemTitle.propTypes = {
  placeholder: PropTypes.string.isRequired,
  byline: PropTypes.string,
  onClickExpand: PropTypes.func,
  doShowExpandMore: PropTypes.bool,
};

BookingItemTitle.defaultProps = {
  byline: null,
  onClickExpand: undefined,
  doShowExpandMore: true,
};

export default memo(BookingItemTitle);
